import { useMemo } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useCompanies } from '../../components/selectors/GlobalCompanySelector/CompanyContext';
import { useDocumentTitle } from '../../components/useDocumentTitle';
import { VIEW_MODE } from './eventInterface';
import './Events.css';

export const Events = () => {
    const { companyId } = useCompanies()!;
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const view = useMemo(() => pathname.split('/')[2], [pathname]) as VIEW_MODE;

    useDocumentTitle('Events');

    const handleView = (newView: VIEW_MODE) => {
        let path = `/events/${newView}`;

        if (companyId) path += `?companyId=${companyId}`;

        navigate(path);
    };

    return (
        <div className="events-page">
            <Outlet context={{ companyId, view, handleView }} />
        </div>
    );
};
